import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@ookla/common-ui';
import { Link } from 'gatsby';
import styles from './typeahead.css';

export default class Suggestion extends React.Component {
  static propTypes = {
    name: PropTypes.string,
    icon: PropTypes.string,
    route: PropTypes.string
  };

  render = () => {
    const { route, name, icon } = this.props;
    return (
      <li data-auto="searchSuggestion" className={styles.suggestion}>
        <Link to={route}>
          <Icon className={styles.icon} size="medium" color="light" icon={icon} /> {name}
        </Link>
      </li>
    );
  };
}
